





















import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import PendingInvitationsComponent from "@/app/components/manageSpace/components/users/inviteUsers/pendingInvitations.component.vue";
import InvitationFormComponent from "@/app/components/manageSpace/components/users/inviteUsers/invitationForm.component.vue";
import UserValidator from "@/resources/mixins/userValidator";
@Component({
  name: "invite-users-component",
  components: {
    InvitationFormComponent,
    PendingInvitationsComponent,
  },
})
export default class InviteUsersComponent extends mixins(
  NotificationEvent,
  UserValidator
) {
  activeTap = 1;
  setActiveTap(value) {
    this.activeTap = value;
  }
}
